<template>
    <div class="inline-block cursor-pointer align-middle" :class="getClass()" @click="$emit('input', !value)"></div>
</template>
<script>
export default {
    props: {
        value: Boolean
    },
    methods: {
        getClass() {
            return this.value ? 'sprite-icons-desc' : 'sprite-icons-asc'
        }
    }
}
</script>